/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Risks_ContentInputs */

const en_home_risks_content = /** @type {(inputs: Home_Risks_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI can have amazing benefits, but it could also erode our democracy, destabilize our economy and could be used to create powerful cyber weapons. Also many AI labs and experts agree: AI could end humanity.`)
};

/**
* | output |
* | --- |
* | "AI can have amazing benefits, but it could also erode our democracy, destabilize our economy and could be used to create powerful cyber weapons. Also many AI..." |
*
* @param {Home_Risks_ContentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_risks_content = /** @type {((inputs?: Home_Risks_ContentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Risks_ContentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_risks_content(inputs)
});